import React, { createContext, useState } from "react";
import all_product from "../Components/Assets/all_product";

// Create a context to share the product data globally
export const ShopContext = createContext(null);

// Function to get the default cart with 0 items for each product
const getDefaultCart = () => {
  let cart = {};
  all_product.forEach((product) => {
    cart[product.id] = 0;
  });
  return cart;
};

const ShopContextProvider = (props) => {
  const [cartItems, setCartItems] = useState(getDefaultCart);
  const [selectedSizes, setSelectedSizes] = useState({});
  const [orderDetails, setOrderDetails] = useState(null); // State to store order details

  // Add item to cart
  const addToCart = (itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] + 1 }));
  };

  // Remove item from cart
  const removeFromCart = (itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] - 1 }));
  };

  // Update the selected size for a product
  const updateSizeSelection = (productId, size) => {
    setSelectedSizes((prevSizes) => ({
      ...prevSizes,
      [productId]: size,
    }));
  };

  // Save order details (product, size, price, quantity)
  const saveOrderDetails = (product, size, price, quantity) => {
    setOrderDetails({
      product,
      size,
      price,
      quantity,
      total: price * quantity, // Calculate the total amount
    });
  };

  // Calculate the total cart amount
  const getTotalCartAmount = () => {
    let shippingcharges = 200;
    let totalAmount = 0;
    for (const item in cartItems) {
      if (cartItems[item] > 0) {
        let itemInfo = all_product.find((product) => product.id === Number(item));
        let selectedSize = selectedSizes[itemInfo.id];
        let adjustedPrice = itemInfo.new_price;

        if (selectedSize === "Unstitched") {
          adjustedPrice = itemInfo.new_price - 1000;
        }

        totalAmount += adjustedPrice * cartItems[item];
      }
    }
    return totalAmount;
  };

  const contextValue = {
    getTotalCartAmount,
    all_product,
    cartItems,
    addToCart,
    removeFromCart,
    selectedSizes,
    updateSizeSelection,
    saveOrderDetails, // Make saveOrderDetails available in the context
  };

  return (
    <ShopContext.Provider value={contextValue}>
      {props.children}
    </ShopContext.Provider>
  );
};

export default ShopContextProvider;
